"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHandler = void 0;
const router_1 = require("@keplr-wallet/router");
const messages_1 = require("./messages");
const getHandler = (service) => {
    return (env, msg) => {
        switch (msg.constructor) {
            case messages_1.ApproveInteractionMsg:
                return handleApproveInteractionMsg(service)(env, msg);
            case messages_1.RejectInteractionMsg:
                return handleRejectInteractionMsg(service)(env, msg);
            default:
                throw new router_1.KeplrError("interaction", 100, "Unknown msg type");
        }
    };
};
exports.getHandler = getHandler;
const handleApproveInteractionMsg = (service) => {
    return (_, msg) => {
        return service.approve(msg.id, msg.result);
    };
};
const handleRejectInteractionMsg = (service) => {
    return (_, msg) => {
        return service.reject(msg.id);
    };
};
//# sourceMappingURL=handler.js.map